import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import PageTitle from "../../../components/Common/PageTitle/index";
import {
  wheelOfLifeCategories,
  wheelOfLifeCategoryColors,
} from "../../../assets/data/data";
import ContentCard from "../../../components/Content/ContentCard/index";
import WheelOfLifeModal from "../../../components/Modals/WheelOfLifeModal";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../../components/Common/CustomSnackbar";
import { getWheelOfLife } from "../../../redux/actions/user.dispatcher";
import {
  PAGE_TITLE,
  PAGE_TEXT,
  VIDEO_URL,
  SNACKBAR_SUCCESS_MESSAGE,
  SECTION_TITLES,
  FOOTER_TEXT,
  LIFE_MASTERY_DATA,
} from "./Mastery.constants";
import { FooterText } from "../../../components/Common/FooterText";
import {
  RootBox,
  StyledBackdrop,
  GridContainer,
  GridItem,
  SectionTitle,
} from "./Mastery.styles";

const Mastery = () => {
  const dispatch = useDispatch();
  const { wheelOfLifeData } = useSelector((state) => state.user);

  const [wheelOfLife, setWheelOfLife] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorState, setErrorState] = useState({
    error: false,
    message: "",
  });
  const [chartData, setChartData] = useState(
    wheelOfLifeCategories.map((category, index) => ({
      label: category.label,
      value: 0,
      field: category.value,
      color: wheelOfLifeCategoryColors[index],
    }))
  );
  const [date, setDate] = useState(null);

  useEffect(() => {
    dispatch(getWheelOfLife());
  }, [dispatch]);

  useEffect(() => {
    if (!date) {
      const allDates = wheelOfLifeData.map((entry) =>
        new Date(entry?.date).toDateString()
      );
      setDate(dayjs(allDates[0]));
    }
  }, [date, wheelOfLifeData, success]);

  useEffect(() => {
    if (date) {
      const entry = wheelOfLifeData.filter((e) =>
        dayjs(e.date).isSame(date, "day")
      );
      if (entry?.length) {
        setChartData(
          wheelOfLifeCategories.map((category, index) => ({
            label: category.label,
            value: entry[0]?.[category.value] || 0,
            field: category.value,
            color: wheelOfLifeCategoryColors[index],
          }))
        );
      }
    }
  }, [date, wheelOfLifeData]);

  const handleCardClick = (item) => () => {
    if (item.link) {
      window.open(item.link, "_blank");
    }
  };

  const handleHeaderClick = () => setWheelOfLife(true);

  return (
    <RootBox>
      <StyledBackdrop open={loading}>
        <CircularProgress color="inherit" />
      </StyledBackdrop>
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={() => setSuccess(false)}
        text={SNACKBAR_SUCCESS_MESSAGE}
      />
      <PageTitle
        title={PAGE_TITLE}
        text={PAGE_TEXT}
        noIcon
        videoUrl={VIDEO_URL}
      />

      <GridContainer container spacing={2}>
        <GridItem item size={{ xs: 12 }}>
          <SectionTitle>{SECTION_TITLES.ACCESS}</SectionTitle>
        </GridItem>

        {LIFE_MASTERY_DATA.map((item, index) => (
          <React.Fragment key={item.id}>
            <GridItem item size={{ xs: 12, md: 12, lg: 6 }}>
              <ContentCard
                item={item}
                size={item.size || 6}
                height={item.bigH ? "350px" : item.height || "200px"}
                clickable={!!item.link}
                onClick={handleCardClick(item)}
                headerClickAble={item.openModalHeader}
                headerOnClick={handleHeaderClick}
                date={date}
                setDate={setDate}
                chartData={chartData}
              />
            </GridItem>

            {index === 1 && (
              <GridItem item size={{ xs: 12 }}>
                <SectionTitle>{SECTION_TITLES.TWO_PART_PROCESS}</SectionTitle>
              </GridItem>
            )}
          </React.Fragment>
        ))}
      </GridContainer>

      <WheelOfLifeModal
        open={wheelOfLife}
        handleClose={() => setWheelOfLife(false)}
        setloading={setLoading}
        setsuccess={setSuccess}
        seterrorState={setErrorState}
        setWOLDate={setDate}
      />

      <FooterText>{FOOTER_TEXT}</FooterText>
    </RootBox>
  );
};

export default Mastery;
